import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { USER_ROLES } from "@store/constants";
import { useSelector } from "react-redux";

const useCanSeeAccountCenter = () => {
    return useSelector((state: ApplicationState) => {
        const userRoles = state.context.session?.userRoles;

        return userRoles?.includes(USER_ROLES.administrator) || userRoles?.includes(USER_ROLES.canPlaceOrder);
    });
};

export default useCanSeeAccountCenter;
